<template>
    <div class="check_purchaseId">
        <div class="check_Top">
            <div class="check_header">
                <router-link to="/godownentry">
                    <el-button size="small" type="primary"><i class="iconfont icon-fanhui-"></i>
                        {{ $t('other.a605') }}</el-button>
                </router-link>

            </div>
            <div class="check_desc">
                <span class="check_desc_item">{{ $t('other.a515') }}： {{ datalist.purchaseOrderId ? datalist.purchaseOrderId
                    :
                    0 }}</span>
                <span class="check_desc_item">{{ $t('other.a1554') }}： {{ datalist.orderFlag ?
                    getStatusLable(datalist.orderFlag) : 0 }}</span>
                <span class="check_desc_item">{{ $t('other.a1509') }}： {{ datalist.total ? datalist.total : 0 }}</span>
                <span class="check_desc_item">{{ $t('other.a1555') }}： {{ datalist.createTime ? getTime(datalist.createTime)
                    :
                    0 }}</span>
                <span class="check_desc_item"><el-button size="medium" type="primary" @click="scanGung()">{{
                    $t('other.a1556') }}</el-button></span>
            </div>
            <div class="check_desc">
                <span class="sec_item">
                    <span class="check_desc_item">{{ $t('other.a1557') }}： {{ datalist.storeId ? datalist.storeId : 0
                    }}</span>
                    <span class="check_desc_item">{{ $t('other.a1526') }}：{{ this.listCopy.total }}</span>
                    <span class="check_desc_item">{{ $t('other.a1558') }}：{{ datalist.userId }}</span>
                    <span class="check_desc_item">{{ $t('other.a499') }}：{{ datalist.messageToSeller ?
                        datalist.messageToSeller
                        : $t('other.a1527') }}</span>
                    <span class="check_desc_item" style="color:red">{{ $t('other.a1559') }}：<el-input size="mini"
                            style="width:120px" type="text" v-model="listCopy.extraCharge"
                            :placeholder="$t('other.a1560')"></el-input></span>
                </span>
                <el-button v-show="!isEedit" type="primary" @click="createOrder()">{{ $t('other.a1561') }}</el-button>
            </div>
        </div>
        <div class="check_table">
            <div style="width:30%">
                <el-table :data="datalist.variantList" border>
                    <el-table-column width="60" :show-overflow-tooltip="true">
                        <template slot-scope="images">
                            <el-popover placement="top-start" title="" trigger="hover">
                                <img :src="images.row.image" alt="" style="width: 150px;height: 150px">
                                <img slot="reference" :src="images.row.image" style="width: 30px;height: 30px">
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column property="cusCode" :label="$t('other.a67')"
                        :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column property="variantName" label="sku" :show-overflow-tooltip="true"></el-table-column>
                    <!-- <el-table-column property="anotherName" :label="$t('sellerpurchase').anthoeName"  :show-overflow-tooltip="true"></el-table-column> -->
                    <el-table-column property="variantNum" :label="$t('sellerpurchase').Purchase_quantity"
                        :show-overflow-tooltip="true"></el-table-column>
                </el-table>
            </div>
            <div style="margin-left:15px ;width:70%">
                <el-table :data="listCopy.variantList" border>
                    <el-table-column width="60" :show-overflow-tooltip="true">
                        <template slot-scope="images">
                            <el-popover placement="top-start" title="" trigger="hover">
                                <img :src="images.row.image" alt="" style="width: 150px;height: 150px">
                                <img slot="reference" :src="images.row.image" style="width: 30px;height: 30px">
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column property="cusCode" :label="$t('other.a67')"
                        :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column property="variantName" label="sku" :show-overflow-tooltip="true"></el-table-column>
                    <!-- <el-table-column property="anotherName" :label="$t('sellerpurchase').anthoeName"  :show-overflow-tooltip="true"></el-table-column> -->
                    <el-table-column property="variantNum" width="160" :label="$t('other.a1510')"
                        :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <el-input-number v-show="!isEedit" @change="getTotal" size="mini" v-model="scope.row.variantNum"
                                :min="0"></el-input-number>
                            <span v-show="isEedit">{{ scope.row.variantNum }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column property="variantNum" :label="$t('other.a1562')" :show-overflow-tooltip="true">
                        <template slot="header" slot-scope="scope">
                            <div>
                                <div>{{ $t('other.a1562') }}</div>
                                <el-button type="text" size="mini" @click="openBitch(1)">批量设置</el-button>
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <el-input v-show="!isEedit" size="mini" v-model="scope.row.packageLength"></el-input>
                            <span v-show="isEedit">{{ scope.row.packageLength }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column property="variantNum" :label="$t('other.a1563')" :show-overflow-tooltip="true">
                        <template slot="header" slot-scope="scope">
                            <div>
                                <div>{{ $t('other.a1563') }}</div>
                                <el-button type="text" size="mini" @click="openBitch(2)">批量设置</el-button>
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <el-input v-show="!isEedit" size="mini" v-model="scope.row.packageWidth"></el-input>
                            <span v-show="isEedit">{{ scope.row.packageWidth }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column property="variantNum" :label="$t('other.a1564')" :show-overflow-tooltip="true">
                        <template slot="header" slot-scope="scope">
                            <div>
                                <div>{{ $t('other.a1564') }}</div>
                                <el-button type="text" size="mini" @click="openBitch(3)">批量设置</el-button>
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <el-input v-show="!isEedit" size="mini" v-model="scope.row.packageHeight"></el-input>
                            <span v-show="isEedit">{{ scope.row.packageHeight }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column property="weight" :label="$t('other.a1565')" :show-overflow-tooltip="true">
                        <template slot="header" slot-scope="scope">
                            <div>
                                <div>{{ $t('other.a1565') }}</div>
                                <el-button type="text" size="mini" @click="openBitch(4)">批量设置</el-button>
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <el-input v-show="!isEedit" size="mini" v-model="scope.row.weight"></el-input>
                            <span v-show="isEedit">{{ scope.row.weight }}</span>
                        </template>
                    </el-table-column>
                </el-table>

            </div>

        </div>
        <div v-if="!isEedit" class="textarea">
            <el-input type="textarea" :rows="3" :placeholder="$t('other.a1566')" v-model="textarea">
            </el-input>
        </div>
        <el-dialog title="批量设置" :visible.sync="dialogBitchVisible" width="30%" :before-close="handleClose">
            <el-input v-model="bitchNum"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogBitchVisible = false">{{ $t('other.a106') }}</el-button>
                <el-button type="primary" @click="setBitch">{{ $t('other.a279') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import sellerpurchaseApi from '.././../api/moudles/sellerpurchase'
import api from '../../api/api.js'
import utils from '../../utils/utils'
export default {
    data() {
        return {
            allStoreId: JSON.parse(localStorage.getItem('userInfo')).storeIds,
            userId: JSON.parse(localStorage.getItem('userInfo')).userId,
            getDataList: null,
            datalist: {},
            listCopy: {},
            isEedit: false,
            textarea: '',
            statusAll: [{
                value: 0,
                stus: '',
                label: this.$t('sellerpurchase').All_inbound_orders
            }, {
                value: 1,
                stus: 'UNAUDITED',
                label: this.$t('sellerpurchase').wait_store_check
            }, {
                value: 2,
                stus: 'STORE_AUDITED',
                label: this.$t('sellerpurchase').wait_check_in
            }, {
                value: 3,
                stus: 'SELLER_AUDITED',
                label: this.$t('sellerpurchase').aleady_check_in
            }],
            checkIndex: 1,
            dialogBitchVisible: false,
            bitchNum: '',
        }
    },


    created() {

        this.getPurchaserData()

    },
    methods: {
        openBitch(index) {
            this.checkIndex = index
            this.bitchNum = ''
            this.dialogBitchVisible = true
        },
        setBitch() {
            if (this.bitchNum != '') {
                for (let i = 0; i < this.listCopy.variantList.length; i++) {
                    if (this.checkIndex == 1) {
                        this.listCopy.variantList[i].packageLength = this.bitchNum
                    } else if (this.checkIndex == 2) {
                        this.listCopy.variantList[i].packageWidth = this.bitchNum
                    } else if (this.checkIndex == 3) {
                        this.listCopy.variantList[i].packageHeight = this.bitchNum
                    } else if (this.checkIndex == 4) {
                        this.listCopy.variantList[i].weight = this.bitchNum
                    }
                }
            }
            this.dialogBitchVisible = false
        },
        scanGung() {
            const { href } = this.$router.resolve({
                name: 'scanIntoStoreage',
                query: {
                    purchaseOrderId: this.datalist.purchaseOrderId
                }


            })
            window.open(href)
        },

        init() {
            if (this.datalist.orderFlag == "UNAUDITED") {
                alert(777)
                this.isEedit = true
            }
        },

        getTotal() {
            this.listCopy.total = 0
            this.listCopy.variantList.forEach(p => {
                this.listCopy.total += p.variantNum
            })
        },

        createOrder() {
            for (let i = 0; i < this.listCopy.variantList.length; i++) {
                if (!Number(this.listCopy.variantList[i].packageHeight) || !Number(this.listCopy.variantList[i].packageLength) || !Number(this.listCopy.variantList[i].packageWidth) || !Number(this.listCopy.variantList[i].weight)) {
                    this.$message.warning(this.$t('other.a1567'))
                    return
                }
            }

            console.log(this.listCopy)

            let text = ""
            let flag = ""
            this.listCopy.total = 0

            this.listCopy.extraCharge = Number(this.listCopy.extraCharge)
            this.listCopy.variantList.forEach(p => {
                this.listCopy.total += p.variantNum
            })
            console.log(this.listCopy)
            if (this.listCopy.total === this.datalist.total) {
                text = this.$t('other.a1568')
                flag = "success"
            } else {
                text = this.$t('other.a1569')
                flag = "error"
            }

            console.log(this.listCopy)

            let obj = JSON.parse(JSON.stringify(this.listCopy))

            obj.extraCharge = Number(obj.extraCharge)

            console.log(obj)

            this.$confirm(text, this.$t("other.a142"), {
                confirmButtonText: this.$t('other.a145'),
                cancelButtonText: this.$t('other.a146'),
                type: flag
            }).then(() => {
                obj.createTime = '';
                obj.messageToSeller = this.textarea
                let param = {
                    order: this.datalist,
                    orderCopy: obj,
                    userId: this.userId
                }

                param.order.variantList.forEach(p => {
                    p.storeItem = null
                })
                param.orderCopy.variantList.forEach(p => {
                    p.storeItem = null
                })


                api.auditPurchaseOrder(param).then(res => {
                    if (res.code === 200) {
                        this.isEedit = true
                        this.$message.success(this.$t('other.a1570'))
                        this.datalist.orderFlag = 'STORE_AUDITED'
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            })
        },

        getStatusLable(value) {
            return this.statusAll.find(status => {
                return status.stus == value
            }).label;
        },

        getPurchaserData() {
            this.getDataList = {
                offset: 15,
                page: 0,
                purchaseOrderId: this.$route.query.purchaserid,
                seller: null,
                storeIds: this.allStoreId,
                type: null,
                userId: this.userId
            }


            sellerpurchaseApi
                .getPurchaseOrder(this.getDataList)
                .then(res => {
                    if (res.code === 200) {
                        console.log('数据', res.data)
                        this.datalist = res.data.list[0]
                        this.datalist.total = 0
                        this.datalist.variantList.forEach(p => {
                            this.datalist.total += p.variantNum
                        })

                        if (this.datalist.orderFlag !== "UNAUDITED") {
                            this.isEedit = true
                        }

                        this.listCopy = JSON.parse(JSON.stringify(this.datalist))

                        // if(this.datalist.orderFlag == '"UNAUDITED"'){

                        // }else{
                        //     this.listCopy=JSON.parse(JSON.stringify(res.data.list[0].copyOrder))
                        // }



                        console.log(this.datalist)
                    }
                })
        },
        getTime(time) {
            return utils.renderTime(time)
        }

    }
}

</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";

.check_purchaseId {
    // @include  main-right-content();


    .check_desc {
        display: flex;
        margin: 10px 0;
        align-items: center;

        .check_desc_item {
            margin: 5px 10px;
        }

        .sec_item {


            display: flex;
            justify-content: space-between;
        }
    }

    .check_desc:nth-child(3) {
        display: flex;
        justify-content: space-between;
        padding-right: 15px;
        align-items: center;
    }


    .check_Top {
        position: fixed;
        z-index: 99;
        top: 50px;
        width: calc(100% - 235px);
        background-color: #fff;
        border-bottom: 1px solid #eee;


    }

    .check_header {
        padding: 10px 0;
    }

    .check_table {
        display: flex;
        justify-content: flex-start;
        margin-top: 160px;
        width: calc(100% - 15px);
    }

    .textarea {
        margin-bottom: 100px;
        margin-top: 10px;
    }

}
</style>